'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

var _handlers = require('q/js/handlers');

var _Checker = require('Reagan/components/Checker');

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _TallyLoader = require('tally-loader-react/TallyLoader');

var _TallyLoader2 = _interopRequireDefault(_TallyLoader);

var _url = require('MeetingsBase/utils/url');

var _createBookingComponent = require('MeetingsLib/components/createBookingComponent');

var _createBookingComponent2 = _interopRequireDefault(_createBookingComponent);

var _underscore = require('underscore');

var _pick = require('transmute/pick');

var _pick2 = _interopRequireDefault(_pick);

var _omit = require('transmute/omit');

var _omit2 = _interopRequireDefault(_omit);

var _keySeq = require('transmute/keySeq');

var _keySeq2 = _interopRequireDefault(_keySeq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var mapFalsyParamsToNull = function mapFalsyParamsToNull(_ref) {
  var params = _ref.params;

  return (0, _underscore.mapObject)(params, function (value) {
    return value || null;
  });
};

var Application = function () {
  function Application() {
    _classCallCheck(this, Application);
  }

  _createClass(Application, [{
    key: 'init',
    value: function init() {
      var _this = this;

      (0, _handlers.logQPromiseIssuesAndSendAlerts)();
      _I18n2.default.when('ready', function () {
        return _this.launch();
      });
    }
  }, {
    key: 'loadTally',
    value: function loadTally(embedded, forceOffline) {
      if (embedded || forceOffline) {
        return null;
      }
      return _react2.default.createElement(_TallyLoader2.default, null);
    }
  }, {
    key: 'launch',
    value: function launch() {
      var url = new _hubspotUrlinator2.default(window.location);
      var slug = (0, _url.getSlug)(window.location.href);
      var embedded = url.paramValue('embed') === 'true';
      var forceOffline = url.paramValue('forceOffline') === 'true';
      var troubleshooting = url.paramValue('troubleshoot') === 'true';
      var urlParams = mapFalsyParamsToNull(url);
      var trackingParams = (0, _pick2.default)(['utm_campaign', 'utm_source', 'utm_medium', 'meeting_funnel', 'meeting_product', 'meeting_medium', 'meeting_type', 'meeting_source', 'meeting_campaign', 'source_app'], urlParams);

      var parentPageHSAnalyticsInfo = (0, _pick2.default)(['parentPageUrl', 'parentHubspotUtk'], urlParams);
      var formFieldUrlParams = (0, _omit2.default)((0, _keySeq2.default)(parentPageHSAnalyticsInfo), (0, _omit2.default)((0, _keySeq2.default)(trackingParams), urlParams));

      var firstName = formFieldUrlParams.firstName,
          lastName = formFieldUrlParams.lastName,
          email = formFieldUrlParams.email,
          customFormFields = _objectWithoutProperties(formFieldUrlParams, ['firstName', 'lastName', 'email']);

      if (window.performance && window.performance.mark) {
        window.performance.mark('create-booking-component');
      }
      var BookingComponent = (0, _createBookingComponent2.default)({
        httpClient: _noAuthApiClient2.default,
        slug: slug,
        embedded: embedded,
        forceOffline: forceOffline,
        troubleshooting: troubleshooting,
        trackingParams: trackingParams,
        formState: {
          firstName: firstName,
          lastName: lastName,
          email: email,
          customFormFields: customFormFields
        },
        parentPageHSAnalyticsInfo: parentPageHSAnalyticsInfo
      });

      var WrappedComponent = (0, _Checker.checker)({
        selectors: {
          success: {
            app: '.meetings-page .compact-container .date-picker-btn.valid, .meetings-page .time-picker:not(.time-picker-skeleton) .time-picker-btn, .meetings-page .prebook-zero-state, .meetings-error > .link-not-found, .email-form'
          },
          error: {
            iceCream: '.meetings-error > :not(.link-not-found)'
          }
        },
        checkOnChange: false
      })(BookingComponent);

      var appRoute = document.getElementsByClassName('page')[0];

      window.disabledHsPopups = ['LEADFLOW', 'FEEDBACK'];

      if (embedded) {
        appRoute.className += 'embedded';

        // set disabled popups so that scripts don't load twice
        // (once on parent page and once in iframe) on embedded meetings
        window.disabledHsPopups.push('PRIVACY', 'ADS', 'LIVE_CHAT');

        // set __hsUserToken as utk passed in from parent page so
        // analytics tracker will init with consistent utk across iframe and parent
        // otherwise, we have form submission and view with incorrect source
        window.__hsUserToken = urlParams.parentHubspotUtk;
      }

      _reactDom2.default.render(_react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(WrappedComponent, { hideLogo: embedded }),
        this.loadTally(embedded, forceOffline)
      ), appRoute);
    }
  }]);

  return Application;
}();

exports.default = Application;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = 239
// module chunks = 0